export const payproCheckoutUrl = "https://store.payproglobal.com/checkout"
